import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes, elevation } from "@similarweb/styles";
import type { StackProps } from "@similarweb/ui-components/foundations";
import { Box, Stack, Text } from "@similarweb/ui-components/foundations";

type ProvidersPanelProps = StackProps & {
    readonly titleKey?: string;
    readonly subtitleKey?: string;
    readonly children: ReactNode;
};

export const ProvidersPanel = ({ titleKey = "", subtitleKey = "", children, ...stackProps }: ProvidersPanelProps) => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="16px"
            padding="16px 0 16px 16px"
            background={colorsPalettes.carbon[0]}
            border={`1px solid ${colorsPalettes.carbon[50]}`}
            borderRadius="8px"
            boxShadow={elevation.Z1}
            {...stackProps}
        >
            {titleKey || subtitleKey ? (
                <Stack padding="0 16px 0 0">
                    {titleKey ? (
                        <Text
                            fontVariant="h5_2"
                            color={colorsPalettes.carbon[500]}
                        >
                            {translate(titleKey)}
                        </Text>
                    ) : null}
                    {subtitleKey ? (
                        <Text
                            fontVariant="caption"
                            color={colorsPalettes.carbon[300]}
                            margin="4px 0 0"
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                __html: translate(subtitleKey),
                            }}
                        />
                    ) : null}
                </Stack>
            ) : null}
            <Box
                overflow="auto"
                padding="0 16px 0 0"
            >
                {children}
            </Box>
        </Stack>
    );
};
